export default __webpack_public_path__ + "static/media/1616c67a1a7767906f637b0732def7c4.93ab0dc2.png";